import { defineComponent as n, useCssModule as a, openBlock as e, createElementBlock as o, normalizeClass as l, unref as d, Fragment as c, renderList as p, mergeProps as u, createVNode as f } from "vue";
import m from "../image/CdrImg.vue.mjs";
const g = "cdr-picture", P = /* @__PURE__ */ n({
  name: "CdrPicture",
  __name: "CdrPicture",
  props: {
    sources: {},
    src: {},
    alt: {
      default: ""
    },
    srcset: {},
    sizes: {},
    fit: {},
    position: {},
    radius: {},
    ratio: {},
    loading: {},
    decoding: {},
    fetchpriority: {}
  },
  setup(C) {
    const t = a();
    return (r, y) => (e(), o("picture", {
      class: l(d(t)[g])
    }, [(e(!0), o(c, null, p(r.sources, (i, s) => (e(), o("source", u({
      key: `${i.media}--${s}`,
      ref_for: !0
    }, i), null, 16))), 128)), f(m, {
      src: r.src,
      alt: r.alt,
      ratio: r.ratio,
      fit: r.fit,
      position: r.position,
      loading: r.loading,
      fetchpriority: r.fetchpriority,
      decoding: r.decoding
    }, null, 8, ["src", "alt", "ratio", "fit", "position", "loading", "fetchpriority", "decoding"])], 2));
  }
});
export {
  P as default
};
